import { IController, ITimeoutService } from 'angular';
import { inject, injectable } from '../../../shared/utils/inject/inject';
import { IEventsService } from '../../services/eventsService/eventsService.factory';
import { IHeightCalc } from '../../services/heightCalc/heightCalc.factory';
import { ISocialService } from '../../services/socialService/socialService.factory';
import { IWixBinding } from '../../services/wix/wixBinding';

@injectable
export class NoShowsController implements IController {
  @inject private wixBinding: IWixBinding;
  @inject private eventsService: IEventsService;
  @inject private socialService: ISocialService;
  @inject private heightCalc: IHeightCalc;
  @inject private $timeout: ITimeoutService;

  $onInit(): void {
    this.$timeout(() => {
      this.heightCalc.resizeNoShows();
    });
  }

  public get name() {
    return this.wixBinding.getSettings().name || 'Artist Name';
  }

  public get local() {
    return this.eventsService.local;
  }

  public get urls() {
    return this.socialService.urls;
  }
}
